import { Card } from "primereact/card";

const Unauthorized = () => {
  return (
    <Card title="Access denied" className="m-2">
      <div>
        <strong>You do not have permission to view this page.</strong>
      </div>
    </Card>
  );
};

export default Unauthorized;
